import React, { FC } from 'react';

import styles from './VaultCardBody.module.scss';

interface Props {
  vault: any;
}

const VaultCardBody: FC<Props> = ({ vault }) => {
  return <div className={styles.body}>card content</div>;
};

export default VaultCardBody;
